import {useEffect} from 'react';

const useOnScreenResize = (callback: () => void) => {
  useEffect(() => {
    window.addEventListener('resize', callback);
    return () => {
      window.removeEventListener('resize', callback);
    };
  }, [callback]);
};

export default useOnScreenResize;
